import React from 'react';
import { Header } from './Header';
import { Navigation } from './Navigation';
import { AdPlaceholder } from './AdPlaceholder';
import { SubNavigation } from './SubNavigation';
import { Link } from 'react-router-dom';
export function MarketIQLayout({
  children,
  activeSection
}: {
  children: React.ReactNode;
  activeSection?: 'beef' | 'pork' | 'chicken' | null;
}) {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-160">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-161">
        <Header data-id="element-162" />
        <Navigation data-id="element-163" />
      </div>

      <SubNavigation activeSection={activeSection} data-id="element-164" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-165">
        {/* Banner Ad */}
        <div className="py-6 flex justify-center" data-id="element-166">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[90px]" text="Advertisement" data-id="element-167" />
        </div>

        {/* Breadcrumb */}
        <nav className="text-sm text-gray-600 mb-8" data-id="element-168">
          <Link to="/" className="text-[#002f5f] hover:underline" data-id="element-169">
            Home
          </Link>
          <span className="mx-1" data-id="element-170">»</span>
          {activeSection ? <>
              <Link to="/market-iq" className="text-[#002f5f] hover:underline" data-id="element-171">
                Market IQ
              </Link>
              <span className="mx-1" data-id="element-172">»</span>
              <span className="text-gray-900 capitalize" data-id="element-173">{activeSection}</span>
            </> : <span className="text-gray-900" data-id="element-174">Market IQ</span>}
        </nav>
      </div>

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-175">
        {children}
      </div>

      {/* Footer */}
      <footer className="mt-auto bg-gray-100 border-t border-gray-200" data-id="element-176">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-177">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-6" data-id="element-178">
            <div className="text-2xl font-bold tracking-tight text-gray-400" data-id="element-179">
              SOSLAND PUBLISHING
            </div>
            <div className="flex items-center gap-3" data-id="element-180">
              <a href="#" className="w-9 h-9 rounded bg-gray-700 flex items-center justify-center text-white text-sm hover:bg-gray-600" data-id="element-181">
                f
              </a>
              <a href="#" className="w-9 h-9 rounded bg-gray-700 flex items-center justify-center text-white text-sm hover:bg-gray-600" data-id="element-182">
                in
              </a>
              <a href="#" className="w-9 h-9 rounded bg-gray-700 flex items-center justify-center text-white text-sm hover:bg-gray-600" data-id="element-183">
                rss
              </a>
            </div>
          </div>

          <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-[#002f5f] mb-4" data-id="element-184">
            <a href="#" className="hover:underline" data-id="element-185">
              Sosland Publishing
            </a>
            <a href="#" className="hover:underline" data-id="element-186">
              Editorial Staff
            </a>
            <a href="#" className="hover:underline" data-id="element-187">
              Subscriptions
            </a>
            <a href="#" className="hover:underline" data-id="element-188">
              Media Guide
            </a>
            <a href="#" className="hover:underline" data-id="element-189">
              Contact Us
            </a>
          </div>

          <p className="text-xs text-gray-500 mb-3" data-id="element-190">
            ©2026 SOSLAND PUBLISHING COMPANY
          </p>

          <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-gray-500" data-id="element-191">
            <a href="#" className="hover:underline" data-id="element-192">
              Privacy Policy
            </a>
            <span data-id="element-193">|</span>
            <a href="#" className="hover:underline" data-id="element-194">
              Terms of Use
            </a>
            <span data-id="element-195">|</span>
            <a href="#" className="hover:underline" data-id="element-196">
              Terms & Conditions for Advertisers
            </a>
            <span data-id="element-197">|</span>
            <a href="#" className="hover:underline" data-id="element-198">
              California Privacy Policy
            </a>
            <span data-id="element-199">|</span>
            <a href="#" className="hover:underline" data-id="element-200">
              Do not sell my information
            </a>
            <span data-id="element-201">|</span>
            <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="hover:underline text-[#002f5f] font-medium" data-id="element-202">
              Data Source & Methodology
            </a>
          </div>

          <p className="text-xs text-gray-400 mt-3" data-id="element-203">
            Design, CMS, Hosting & Web Development :: ePublishing
          </p>
        </div>
      </footer>
    </div>;
}